module.exports = __webpack_public_path__ + "static/media/design5.017dac52.jpg";